import { ROUTE_PATH } from 'common/constants/sm-constants';
import {
  GridMetaModel,
  Headers,
} from 'common/models/utility-models/meta-model';

export class MentorGridMetaModel extends GridMetaModel<Headers> {
  constructor() {
    super(
      'Mentors',
      ROUTE_PATH.mentorList,
      ROUTE_PATH.addMentor,
      true,
      false,
      8,
      false,
      true,
      ['mentorName'],
      true,
      [],
      {
        isDownloadExcel: true,
        excelFileName: 'mentors.xlsx',
        btnLabel: 'Download Mentors Data',
        headers: [
          { key: 'Mentor', value: 'mentorName' },
          { key: 'Contact', value: 'mentorContact' },
          { key: 'State', value: 'stateName' },
          { key: 'Company', value: 'mentorCompany' },
          { key: 'Gender', value: 'mentorGender' },
          { key: 'Assigned', value: 'isAssigned' },
          { key: 'Count', value: 'studentCount' },
        ],
      },
      false,
      { evalKey: 'editActionFlag', evalParam: [0], decisiveParam: false },
      false,
      false,
      false,
      null,
      { evalKey: 'deleteActionFlag', evalParam: [0], decisiveParam: false },
      false,
      null,
      {
        isPreview: false,
        isPreviewType: 'VIDEO',
        isEnvUrl: false,
        linkKey: ['filePath'],
        previewName: '',
      },
      {
        isTabSwitch: false,
        label: '',
        isChecked: false,
      },
      true,
      true,
      true,
      [],
      true,
      {
        isExtraActions: false,
        btnLabel: '',
        selectOptions: [],
        selectedValue: '',
      },
      {
        isCheckboxEmit: false,
        emitKey: '',
        checkedKey: '',
        valueKey: '',
      },
      {
        isDownload: false,
        key: '',
        valueKey: '',
      },
      {
        isTabStatus: false,
        label: '',
        isChecked: false,
      },
      false,
      false,
      {
        isPrimary: true,
        isDanger: false,
      },
      '',
      { value: '', isVisible: false },
      false,
      false,
      true,
      {
        isExtraActions: false,
        btnLabel: '',
        selectOptions: [],
        selectedValue: '',
        isPreviewBtn: false,
        previewBtnLabel: '',
      },
      { value: '', isVisible: false },
      true
    );
  }

  prepareHeaderList(): Headers[] {
    const headers: Headers[] = [];
    const mentorName = new Headers(
      'Mentor Name',
      'mentorName',
      false,
      true,
      'text'
    );
    const mentorContact = new Headers(
      'Mentor Contact',
      'mentorContact',
      false,
      true,
      'text'
    );
    const stateName = new Headers('State', 'stateName', false, true, 'text');
    const mentorCompany = new Headers(
      'Company',
      'mentorCompany',
      false,
      true,
      'text'
    );
    const mentorGender = new Headers(
      'Gender',
      'mentorGender',
      false,
      true,
      'text'
    );
    const mentorAssigned = new Headers(
      'Assigned',
      'isAssigned',
      false,
      true,
      'text'
    );
    const studentCount = new Headers(
      'Student Count',
      'studentCount',
      false,
      true,
      'text'
    );

    //studentCount
    headers.push(mentorName);
    headers.push(mentorCompany);
    headers.push(mentorContact);
    headers.push(stateName);
    headers.push(mentorAssigned);
    headers.push(studentCount);
    headers.push(mentorGender);
    return headers;
  }
}
